var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.9 127.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 52.68h13q9.35 0 13.84-4.68t4.51-12.4c0-5-1.49-8.87-4.46-11.64s-7.03-4.16-12.24-4.16a18.1 18.1 0 00-11.81 3.86 12.38 12.38 0 00-4.76 10.07H1.53a30.24 30.24 0 015.22-17.38 34.92 34.92 0 0114.62-12A48.74 48.74 0 0142.06 0q19.62 0 30.75 9.39t11.13 25.87a26.07 26.07 0 01-5.18 15.63 33.73 33.73 0 01-13.59 11q10.44 3.74 15.59 11.22a30.45 30.45 0 015.14 17.63q0 16.49-12 26.42t-31.84 9.94q-18.53 0-30.29-9.77T0 91.5h24.55a14.25 14.25 0 005.23 11.39 19.27 19.27 0 0012.87 4.42q8.74 0 13.72-4.63t5-12.28q0-18.53-20.39-18.52H28z",
    fill: "#fff"
  })));
}
Svg03.displayName = '03';
export default Svg03;